/**
 * @prop --track-color: The color of the spinner's track.
 * @prop --indicator-color: The color of the spinner's indicator.
 * @prop --stroke-width: The width of the indicator.
 */
:host {
  --track-color: var(--gr-color-light-shade);
  --indicator-color: var(--gr-color-primary);
  --stroke-width: 2px;

  display: inline-flex;

  box-sizing: border-box;

  & *,
  & *:before,
  & *:after {
    box-sizing: inherit;
  }
}

.spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  border: solid var(--stroke-width) var(--track-color);
  border-top-color: var(--indicator-color);
  border-right-color: var(--indicator-color);
  animation: 1s linear infinite spin;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
